import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FaTwitter, FaLinkedin, FaReddit, FaFacebook, FaCopy, FaShareAlt } from 'react-icons/fa';

function ShareButton({ prompt }) {
  const [showMenu, setShowMenu] = useState(false);

  const shareUrl = `${window.location.origin}/prompts/${prompt.id}`;
  const shareText = `Check out this ${prompt.category} prompt: "${prompt.title}" 👻 Rated ${typeof prompt.average_rating === 'number' ? prompt.average_rating.toFixed(1) : 'N/A'}/10 by the community!`;

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}&hashtags=AI,Prompts,Boop`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
    reddit: `https://reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(prompt.title)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied to clipboard!');
      setShowMenu(false);
    } catch (error) {
      toast.error('Failed to copy link');
    }
  };

  const handleShare = (platform) => {
    window.open(shareLinks[platform], '_blank', 'width=600,height=400');
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="flex items-center gap-2 px-4 py-2 bg-boop-primary text-white rounded-lg hover:bg-boop-secondary transition"
      >
        <FaShareAlt />
        Share
      </button>

      {showMenu && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setShowMenu(false)}
          />

          {/* Share Menu */}
          <div className="absolute right-0 mt-2 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-xl z-50 border border-gray-200 dark:border-gray-700">
            <div className="p-3">
              <p className="text-sm font-semibold mb-3 text-gray-700 dark:text-gray-300">
                Share this prompt
              </p>

              <div className="space-y-2">
                {/* Copy Link */}
                <button
                  onClick={copyToClipboard}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                >
                  <FaCopy className="text-gray-600 dark:text-gray-400" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Copy Link</span>
                </button>

                {/* Twitter */}
                <button
                  onClick={() => handleShare('twitter')}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                >
                  <FaTwitter className="text-blue-400" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Twitter</span>
                </button>

                {/* LinkedIn */}
                <button
                  onClick={() => handleShare('linkedin')}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                >
                  <FaLinkedin className="text-blue-600" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">LinkedIn</span>
                </button>

                {/* Reddit */}
                <button
                  onClick={() => handleShare('reddit')}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                >
                  <FaReddit className="text-orange-500" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Reddit</span>
                </button>

                {/* Facebook */}
                <button
                  onClick={() => handleShare('facebook')}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                >
                  <FaFacebook className="text-blue-500" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Facebook</span>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ShareButton;
